<script>
  import { CuratedByDashboard } from '@button/ui';
  import Layout from '../components/Layout.svelte';
  import { addToast } from '../store';
  import { TOAST_SUCCESS } from '../constants';
  import { onMount } from 'svelte';
  import { sendDebugEvent } from '../data/debug';

  function successToast(message) {
    addToast({
      message,
      type: TOAST_SUCCESS,
      timeout: 3000,
    });
  }

  onMount(() => {
    sendDebugEvent('curated-visit-dashboard');
  });
</script>

<Layout>
  <CuratedByDashboard {successToast} />
</Layout>
